var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgLogout = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10.954,
    height: 12,
    viewBox: "0 0 10.954 12",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "logout_FILL0_wght200_GRAD-25_opsz24",
    d: "M174.944-781.846a1.06,1.06,0,0,1-.779-.318,1.064,1.064,0,0,1-.318-.782v-9.8a1.064,1.064,0,0,1,.318-.782,1.06,1.06,0,0,1,.779-.318H179.5v.661h-4.552a.421.421,0,0,0-.3.138.421.421,0,0,0-.138.3v9.8a.421.421,0,0,0,.138.3.421.421,0,0,0,.3.138H179.5v.661Zm7.423-3.57-.471-.462,1.638-1.638h-6.159v-.661h6.159l-1.638-1.638.471-.469,2.433,2.433Z",
    transform: "translate(-173.846 793.846)",
    fill: "#3b3b3b"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLogout, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/logout.2566d272.svg";
export { ForwardRef as ReactComponent };